<!-- Desktop Search Form -->
<form *ngIf="!isMobile" [formGroup]="searchForm" (ngSubmit)="search()" class="search-form">
    <div class="input-group">
        <select formControlName="category" class="form-select">
            <option value="">{{ "All categories" | translate }}</option>
            <option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</option>
        </select>
        <input type="text" formControlName="query" class="form-control" [placeholder]="'Search' | translate" />
        <button type="submit" class="btn btn-primary">
            <i class="bi bi-search"></i>
        </button>
    </div>
</form>

<!-- Mobile Search Form -->
<form *ngIf="isMobile" [formGroup]="searchForm" (ngSubmit)="search()" class="search-form-mobile">
    <div class="input-group">
        <input type="text" formControlName="query" class="form-control" [placeholder]="'Search' | translate" />
        <button type="submit" class="btn btn-primary">
            <i class="bi bi-search"></i>
        </button>
    </div>
</form>
